import axios from "./axios";

export const searchBrokerInstruments = async (qOrOptions = "") => {
  const options =
    typeof qOrOptions === "object" && qOrOptions !== null && !Array.isArray(qOrOptions)
      ? qOrOptions
      : { q: qOrOptions };

  const params = {};
  const { q, exchange } = options;

  if (q != null && q !== "") {
    params.q = Array.isArray(q) ? JSON.stringify(q) : String(q);
  }
  if (exchange) {
    params.exchange = String(exchange).toLowerCase();
  }

  const response = await axios.get("/api/broker-gateway/instrument-search/", {
    params,
  });
  return response.data;
};

export const addWatchlistInstrument = async (instruments) => {
  const payload = Array.isArray(instruments)
    ? instruments
    : [
        {
          exchange_trading_symbol:
            instruments.exchange_trading_symbol || instruments.symbol,
          exchange: instruments.exchange,
        },
      ];

  const response = await axios.post("/api/broker-gateway/get-watchlist-price/", payload);
  return response.data;
};

export const removeWatchlistInstrument = async (instruments) => {
  const payload = Array.isArray(instruments)
    ? instruments
    : [
        {
          exchange_trading_symbol:
            instruments.exchange_trading_symbol ||
            instruments.exchangeTradingSymbol ||
            instruments.symbol ||
            instruments.tradingsymbol,
          exchange: instruments.exchange,
        },
      ];

  const response = await axios.post("/api/broker-gateway/watchlist-delete/", payload);
  return response.data;
};

export const getWatchlist = async () => {
  const response = await axios.get("/api/watchlist");
  return response.data;
};

export const getDefaultWatchlistPrice = async () => {
  const response = await axios.get("/api/broker-gateway/get-default-watchlist-price/");
  return response.data;
};

export const getWatchlistPrice = async () => {
  const response = await axios.get("/api/broker-gateway/get-watchlist-price/");
  return response.data;
};

export const updateWatchlistColors = async (payload) => {
  const response = await axios.post("/api/broker-gateway/watchlist-colors/", payload);
  return response.data;
};
